export const lineListingTypeDataMapping = () => {
    const mapping = [
        {
            "name": "EC Goods",
            "value": 1
        },
        {
            "name": "Triangulation",
            "value": 2
        },
        {
            "name": "EC Services-art, 196",
            "value": 3
        },
        {
            "name": "Services-art, 194",
            "value": 4
        },
        {
            "name": "Transfers",
            "value": 5
        },
        {
            "name": "Transfers after exempted import",
            "value": 6
        },
        {
            "name": "EC goods after exempted import",
            "value": 7
        },
        {
            "name": "Triangulation purchase end customer",
            "value": 8
        },
        {
            "name": "Call-off Stock Transfer",
            "value": 9
        },
        {
            "name": "Call-off Stock Return",
            "value": 10
        },
        {
            "name": "Call-off Stock Change Of acquirer",
            "value": 11
        },
        {
            "name": "Flash sale from under call-off stock",
            "value": 12
        }
    ]
    return mapping;
}

export const getLineTypeMappingLabelById = id => {
    return lineListingTypeDataMapping().filter(obj => obj.value === id) && lineListingTypeDataMapping().filter(obj => obj.value === id)[0]?.name;
}